import { Pipe, PipeTransform } from '@angular/core';
import { VariableBenefitPaymentFrequencyEnum } from '../../../../../models/enum/shared/variable-benefit-payment-frequency.enum';

@Pipe({
  name: 'recurringPaymentFrequency'
})
export class RecurringPaymentFrequencyPipe implements PipeTransform {
  transform(
    amount: number | null | undefined,
    frequency: VariableBenefitPaymentFrequencyEnum | null | undefined
  ): string {
    if (amount === null || frequency === null) {
      return '';
    }

    const formattedAmount = `$${new Intl.NumberFormat('en-CA', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount ?? 0)}`;

    switch (frequency) {
      case VariableBenefitPaymentFrequencyEnum.Monthly:
        return `${formattedAmount} / ${$localize`mo`}`;

      case VariableBenefitPaymentFrequencyEnum.Annually:
        return `${formattedAmount} / ${$localize`yr`}`;

      default:
        return formattedAmount;
    }
  }
}
